export default __webpack_public_path__ + "static/media/business_card_original.09012695.jpg";